import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const GlobalParametersInsuranceSchema = z.object({
  insurancePercentage: z
    .number({
      message: i18nMessage("boParameters:globalParametersForm.insuranceRequired"),
      coerce: true,
    })
    .min(0, { message: i18nMessage("boParameters:globalParametersForm.insuranceNegative") }),
});

export type GlobalParametersInsuranceFormData = z.infer<typeof GlobalParametersInsuranceSchema>;

export const GlobalParametersMembranesPriceSchema = z.object({
  woodBoxMembranesPriceHT: z
    .number({
      message: i18nMessage("boParameters:globalParametersForm.membranesPriceRequired"),
      coerce: true,
    })
    .min(0, { message: i18nMessage("boParameters:globalParametersForm.membranesPriceNegative") }),
});

export type GlobalParametersMembranesPriceFormData = z.infer<
  typeof GlobalParametersMembranesPriceSchema
>;

export const GlobalParametersDefaultPaymentTermSchema = z.object({
  defaultPaymentTerm: z
    .number({
      message: i18nMessage("boParameters:globalParametersForm.paymentTermRequired"),
      coerce: true,
    })
    .min(0, { message: i18nMessage("boParameters:globalParametersForm.paymentTermNegative") }),
});

export type GlobalParametersDefaultPaymentTermFormData = z.infer<
  typeof GlobalParametersDefaultPaymentTermSchema
>;
